import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl22 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_22",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Arrow",
				className: "black",
				d: "M58.92,21.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-5-5c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29h-9.59c-.55,0-1,.45-1,1s.45,1,1,1h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5-5c.09-.09.17-.2.22-.33Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Station",
				className: "black",
				d: "M31,29c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5ZM31,21c-1.66,0-3,1.34-3,3s1.34,3,3,3,3-1.34,3-3-1.34-3-3-3ZM42.99,17.78c-.12-2.67-2.32-4.78-4.99-4.78h-14.22c-2.67.12-4.78,2.32-4.78,5v15h-9.22c-2.67.12-4.78,2.32-4.78,5v14.12c.07.5.49.88,1,.88h20.12c.5-.07.88-.49.88-1v-18.12c.07-.5.49-.88,1-.88h1.12c.5-.07.88-.49.88-1,0-.55-.45-1-1-1h-1.18c-1.59.1-2.82,1.41-2.82,3v17h-4V17.82c.1-1.59,1.41-2.82,3-2.82h14.18c1.59.1,2.82,1.41,2.82,3v11.12c.07.5.49.88,1,.88.55,0,1-.45,1-1v-11.22ZM15,51h-4v-11.09c.07-.5.49-.88,1-.88h2.12s.11.03.11.03c.45.11.77.51.77.97v10.97ZM19,51h-2v-11.15c-.1-1.59-1.41-2.82-3-2.82h-2.18c-1.59.1-2.82,1.41-2.82,3v10.97h-2v-13s0-.18,0-.18c.09-1.59,1.41-2.82,2.99-2.82h9v16Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ICE_Sideview",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M57,49h-27c-.55,0-1-.45-1-1s.45-1,1-1h27c.55,0,1,.45,1,1s-.45,1-1,1Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M48,53h-18c-.55,0-1-.45-1-1s.45-1,1-1h18c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-2.69c-.55,0-1-.45-1-1s.45-1,1-1h2.69c5.5,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M44.76,42.78s-.1,0-.14-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-4.09c-.55,0-1-.45-1-1s.45-1,1-1h4.09c3.64,0,7.01.24,10.31.72l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-5c-.55,0-1-.45-1-1s.45-1,1-1h5c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.45.43.48.74s-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl22;
